import './transferDetailsEdit.scss';

import { Card } from '@transferz/fe-component-library/src/components/card/Card';
import BriefcaseIcon from '@transferz/fe-component-library/src/components/icons/BriefcaseIcon';
import PersonIcon from '@transferz/fe-component-library/src/components/icons/PersonIcon';
import Input from '@transferz/fe-component-library/src/components/input/Input';
import Textarea from '@transferz/fe-component-library/src/components/textarea/Textarea';
import { useLocalize } from 'localize-react';
import React, { ChangeEvent, useContext } from 'react';

import { FormContext } from '../../FormContext';

interface ITransferDetailsEditProps {
  journey: any;
}

export const TransferDetailsEdit: React.FunctionComponent<ITransferDetailsEditProps> = ({
  journey,
}) => {
  const { translate } = useLocalize();
  const { formData, formErrors, setFormData, setFormErrors } = useContext(FormContext);
  const passengerCapacity: number = journey?.quote?.passengerCapacity;
  const luggageCapacity: number = journey?.quote?.luggageCapacity;

  return (
    <div className="card-wrap">
      <Card title={translate('booking_transferDetails')} collapsed={false}>
        <div className="form-input input-block-wrap">
          <div className="passenger-luggage-input">
            <Input
              name="passengers"
              type="number"
              className="form-item"
              label={translate('booking_passengers')}
              iconLeft={<PersonIcon />}
              value={formData?.travellerInfo?.passengerCount || 0}
              onChange={(event: ChangeEvent<HTMLInputElement>) => {
                setFormData({
                  ...formData,
                  travellerInfo: {
                    ...formData.travellerInfo,
                    passengerCount: Number(event.target.value),
                  },
                });
                setFormErrors({
                  ...formErrors,
                  passengerCount: !(passengerCapacity >= Number(event.target.value) && Number(event.target.value) > 0),
                });
              }}
              confirmed={formErrors?.passengerCount !== undefined}
              error={formErrors?.passengerCount
                ? (formData?.travellerInfo?.passengerCount <= 0)
                  ? `${translate('booking_minAmount')} 1`
                  : `${translate('booking_maxAmount')} ${passengerCapacity}`
                : ''}
            />
          </div>
          <div className="passenger-luggage-input">
            <Input
              name="luggage"
              type="number"
              className="form-item"
              label={translate('booking_luggage')}
              iconLeft={<BriefcaseIcon />}
              value={formData?.travellerInfo?.luggageCount || 0}
              onChange={(event: ChangeEvent<HTMLInputElement>) => {
                setFormData({
                  ...formData,
                  travellerInfo: {
                    ...formData.travellerInfo,
                    luggageCount: Number(event.target.value),
                  },
                });
                setFormErrors({
                  ...formErrors,
                  luggageCount: !(luggageCapacity >= Number(event.target.value) && Number(event.target.value) >= 0),
                });
              }}
              confirmed={formErrors?.luggageCount !== undefined}
              error={formErrors?.luggageCount
                ? (formData?.travellerInfo?.luggageCount < 0)
                  ? `${translate('booking_minAmount')} 0`
                  : `${translate('booking_maxAmount')} ${luggageCapacity}`
                : ''}
            />
          </div>
          {/*TODO: Later add Extras dropdown*/}
          <div className="extras-input">
            <Input
              name="extras"
              className="form-item"
              label={translate('booking_extras')}
              defaultValue={journey?.travelAddons?.length > 0
                ? journey?.travelAddons?.map((addon: any) => (`${translate(addon.type)}`)).join(', ')
                : translate('transferDetails_noAddons')}
              onChange={() => { }}
              nonEditable
            />
          </div>
        </div>
        <div>
          <Textarea
            name="driverComments"
            className="form-item"
            label={translate('booking_driverComments')}
            defaultValue={formData?.travellerInfo?.driverComments || ''}
            onChange={(event: ChangeEvent<HTMLTextAreaElement>) => {
              setFormData({
                ...formData,
                travellerInfo: {
                  ...formData.travellerInfo,
                  driverComments: event.target.value,
                },
              });
            }}
          />
        </div>
      </Card>
    </div>
  );
};
